module.exports = __webpack_public_path__ + "static/img/hatchback-bluegrey.f395201.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hatchback-bluegrey.svg
// module id = k7w/
// module chunks = 82